import FrequentlyAskedQuestions from "../../common/FrequentlyAskedQuestions";
import classNames from "./LandingFAQ.module.css";
import phoneImg from "../../../assets/stock/phone.webp";
import { NeedHelp } from "../home/Support";

const LandingFAQ = () => {
  return (
    <div className={classNames.LandingFAQ}>
      <h1>Frequently asked questions</h1>
      <img src={phoneImg} alt="Raised hand" />
      <div className={classNames.Intro}>
        <h3>Have questions? We have answers! 💡</h3>
        <p>
          {
            "Welcome to our FAQ section, where we answer your most common questions about Langfinity (prev. Byrdhouse AI!). Whether you're curious about real-time translation, multi-speaker support, voice avatars, integrations, or pricing, you'll find the answers here. We're here to make multilingual communication effortless for your meetings, events, and global teams. If you don't see what you're looking for, feel free to reach out—we're happy to help! 😊"
          }
        </p>
      </div>
      <FrequentlyAskedQuestions landing={true} />
      <div className={classNames.StillHaveQuestions}>
        <h3>Still have questions?</h3>
        <NeedHelp />
      </div>
    </div>
  );
};

export default LandingFAQ;
